import { render, staticRenderFns } from "./ChatAssignment.vue?vue&type=template&id=3604c252&scoped=true&"
import script from "./ChatAssignment.vue?vue&type=script&lang=js&"
export * from "./ChatAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ChatAssignment.vue?vue&type=style&index=0&id=3604c252&class=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604c252",
  null
  
)

export default component.exports